import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import { translate } from '../../../base/i18n/functions';
import AbstractParticipantsRecordingLabel, { _mapStateToProps } from '../AbstractParticipantsRecordingLabel';
/**
 * Creates the styles for the component.
 *
 * @param {Object} theme - The current UI theme.
 *
 * @returns {Object}
 */
const styles = (theme) => {
    return {
        recordContainer: {
            background: "rgba(33, 33, 33, 0.9)",
            borderRadius: "4px",
            padding: "5px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        record: {
            background: "transparent",
            margin: 0,
            padding: 0,
        },
        recordText: {
            marginLeft: "4px",
            fontFamily: 'Inter Medium',
            fontWeight: 'normal',
            fontSize: '12px',
            lineHeight: '15px',
            color: "rgba(255, 255, 255, 1)",
        },
        recordStopButton: {
            cursor: "pointer",
            background: "transparent",
            margin: "0px 0px 0px 8px",
            padding: 0,
        },
        dotContainer: {
            width: "14px",
            height: "14px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid rgba(255, 79, 71, 1)",
            borderRadius: "100%",
        },
        dotAnimated: {
            width: "6px",
            height: "6px",
            backgroundColor: "rgba(255, 79, 71, 1)",
            borderRadius: "100%",
            animation: "pulse 700ms ease-in-out infinite",
        },
    };
};
/**
 * Implements a React {@link Component} which displays the current state of
 * conference recording.
 *
 * @augments {Component}
 */
class ParticipantsRecordingLabel extends AbstractParticipantsRecordingLabel {
    /**
     * Renders the platform specific label component.
     *
     * @inheritdoc
     */
    _renderLabel() {
        const { _isVisible } = this.props;
        const classes = withStyles.getClasses(this.props);
        if (!_isVisible) {
            return null;
        }
        return (React.createElement("div", { className: classes.recordContainer },
            React.createElement("div", { className: classes.dotContainer },
                React.createElement("div", { className: classes.dotAnimated }))));
    }
}
export default withStyles(translate(connect(_mapStateToProps)(ParticipantsRecordingLabel)), styles);
